export const DRAFT_ID_PREFIX = "draft-";

export type DraftChannel = "email" | "whatsapp";

export type DraftWizard = "ai" | "template";

/** The wizard's form state. Known fields are type-checked by the backend; any other field is kept as is. */
export interface CampaignDraftData {
  schema_version?: number;
  current_step?: number;
  campaign_name?: string;
  send_to?: string[];
  dont_send_to?: string[];
  category_links?: string[];
  tone?: string[];
  campaign_type?: string;
  campaign_subtype?: string;
  prompt?: string;
  persona?: string;
  seasonal_tag?: string;
  offer?: string;
  cta_label?: string;
  cta_url?: string;
  subject_line?: string;
  reply_to?: string;
  [field: string]: unknown;
}

/** Generated output, kept apart from `data` because it is large. */
export interface CampaignDraftContent {
  design?: unknown;
  html?: string;
  recommended_products?: unknown;
}

export type CampaignDraftWarning =
  | { code: "missing_lists"; step: number; lists: string[] }
  | { code: "name_taken"; step: number; taken_by: "campaign" | "draft" };

export interface CampaignDraft {
  draft_id: number;
  tenant_id: number;
  channel: DraftChannel;
  status: string;
  campaign_id: string | null;
  created_by: number | null;
  data: CampaignDraftData;
  content: CampaignDraftContent | null;
  created_at: string;
  updated_at: string;
  warnings?: CampaignDraftWarning[];
}

export interface SaveDraftRequest {
  data: CampaignDraftData;
  /** Leave out to keep the stored content, `null` to clear it. */
  content?: CampaignDraftContent | null;
  expectedUpdatedAt?: string | null;
}

export const SCHEMA_VERSION = 1;

export const isDraftCampaignId = (campaignId: string) => campaignId.startsWith(DRAFT_ID_PREFIX);
